import React from "react"
import {Link} from "react-router-dom";
import {ListGroupItem} from "reactstrap";

import Moment from 'react-moment'
import SmallLoader from "../SmallLoader";

export default class VerifItem extends React.Component {

  componentWillMount() {

  }



  render() {
    const {status} = this.props
    return <ListGroupItem color={status==='running'?'primary':status==='failed'?'danger':status} tag={Link} to={`/deposits/${this.props.depo_id}/verifications/${this.props.id}`}>Created <Moment fromNow date={this.props.timestamp}/> {this.props.id}</ListGroupItem>
  }
}


// WEBPACK FOOTER //
// ./src/components/Deposits/VerifItem.js